import { PureComponent } from 'react'
import styled from 'glamorous'

import { $ } from 'utils'
import { ImagePure } from 'components'


const Container = styled.div({
  flex: 1,
  height: '100%',
  borderRight: 'var(--border)',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-end',
  padding: '30px 30px 0 0'
})

const InnerContainer = styled.div({
  width: '340px',
})

const Header = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 15,
})

const HeaderName = styled.div({
  fontWeight: 'bold',
  fontSize: 19,
})

const HeaderId = styled.div({
  fontSize: 15,
  color: 'var(--lightGrey)'
})

const HeaderIdName = styled.span({
  fontWeight: 'bold',
  fontSize: 15,
  marginRight: 5,
  textTransform: 'uppercase',
  color: 'var(--black)'
})

const Avatar = styled.div({
  position: 'relative',
  marginBottom: 10
})


export default class OriginalFace extends PureComponent {

  render = () => {
    const { descriptor } = this.props
    return (
      $(Container,
        $(InnerContainer,
          $(Header,
            $(HeaderName, 'Original face'),
            $(HeaderId,
              $(HeaderIdName, 'Id:'),
              descriptor.uuid
            )
          ),
          $(Avatar,
            $(ImagePure, {
              src: descriptor.portrait,
              width: 340,
              height: 430
            })
          ),
        )
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/panels/VerificationResults/OriginalFace.js